import React from "react";
import AcademicImage from '../../../assets/images/Academic Image.png'
import CTAButton from "../../Buttons/CTAButton/CTAButton";
import GlobeHemisphereWestk from "../../Icons/GlobeHemisphereWest";
import BookOpenText from "../../Icons/BookOpenText";
import MicroscopeLine from "../../Icons/MicroscopeLine";

const AcademicSection = () => {
  return (
    <div>
      <div className="self-stretch px-4 md:px-8 lg:px-12 pt-16 md:pt-18 lg:pt-32 pb-8 md:pb-12 lg:pb-16 bg-Color-Primary inline-flex flex-col justify-center items-start gap-6 md:gap-8 lg:gap-12">
        <div className="self-stretch p-2 md:p-3 lg:p-4 inline-flex justify-center items-center gap-2">
          <div className="flex-1 px-4 md:px-6 lg:px-8 py-4 border-l-2 border-Color-Black-20/20 inline-flex flex-col justify-end items-start gap-6 md:gap-8 lg:gap-10">
            <div className="self-stretch justify-start">
              <span className="text-Color-White text-3xl md:text-4xl lg:text-6xl font-normal font-['Montserrat']">
                Academic
              </span>
              <span className="text-Color-White text-3xl md:text-4xl lg:text-6xl font-normal font-['Montserrat']">
                {" "}
              </span>
              <span className="text-Color-White text-3xl md:text-4xl lg:text-6xl font-semibold font-['Montserrat'] underline">
                Excellence
              </span>
            </div>
            <div className="self-stretch justify-start text-Color-White text-sm md:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight">
              For 25 remarkable years, we have been committed to providing a
              world-class engineering education, fostering a rigorous learning
              environment, and empowering our students with the knowledge and
              skills necessary to excel in a rapidly evolving global landscape.
            </div>
            <CTAButton  text="READ MORE" url="https://www.eng.ruh.ac.lk/academic/" target="_blank" variant="whiteRainbow" newTab={true} isWhiteButton = {true} />
          </div>
          <div className="hidden lg:flex-1 max-w-full lg:max-w-[600px] p-10 lg:inline-flex flex-col justify-start items-start">
          <img 
                    src="/assets/gradCap.svg" 
                    alt="Background Frame" 
                    className="w-full h-full object-contain"
          />
          </div>
        </div>
        <div className="self-stretch p-6 md:p-8 lg:p-12 bg-Color-White-4/5 rounded-tl-[20px] md:rounded-tl-[30px] lg:rounded-tl-[40px] rounded-br-[20px] md:rounded-br-[30px] lg:rounded-br-[40px] inline-flex flex-col lg:flex-row justify-start items-start gap-6 md:gap-8 lg:gap-12 overflow-hidden bg-Color-White bg-opacity-5">
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 relative overflow-hidden">
              <MicroscopeLine className="w-8 h-8 md:w-10 md:h-10 left-[4px] md:left-[4.50px] top-[4px] md:top-[4.50px] absolute" />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg md:text-xl lg:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight">
              Globally Recognized Programs:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-sm md:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight">
                Accredited by IESL and aligned with the Washington Accord, our
                degrees are respected worldwide, offering global career
                opportunities.
              </div>
            </div>
          </div>
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 relative overflow-hidden">
              <BookOpenText className="w-8 h-7 md:w-10 md:h-9 left-[2px] md:left-[3px] top-[7px] md:top-[9px] absolute" />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg md:text-xl lg:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight">
              Expert-Led, Industry-Relevant Education:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-sm md:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight">
                Learn from experienced professionals who combine academic
                excellence with real-world engineering insight.
              </div>
            </div>
          </div>
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 relative overflow-hidden">
              <GlobeHemisphereWestk className="w-7 h-8 md:w-9 md:h-10 left-[5px] md:left-[6px] top-[2px] md:top-[2.54px] absolute" />
            </div>
            <div className="self-stretch justify-start text-Color-White text-lg md:text-xl lg:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight">
              Hands-On Learning & Innovation:
            </div>
            <div className="self-stretch inline-flex justify-center items-center gap-2">
              <div className="flex-1 justify-start text-Color-White text-sm md:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight">
                Access advanced labs and engage in research-driven, practical
                projects that build critical problem-solving skills.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademicSection;